'use client';
import React, { useEffect, useRef, useState } from 'react';

function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setInView(true);},
      { threshold }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, [threshold]);

  return { ref, inView };
}

export default function AboutUs() {
  const { ref, inView } = useInView();

  return (
    <div className="about-us">
      <div className="dentaire-container">
        <div className="row align-items-center" ref={ref}>
          {/* Left Images */}
          <div className="col-lg-6">
            <div className="about-image">
              <div className="about-img-1">
                <figure className="image-anime reveal" style={{ display: 'block', overflow: 'hidden', borderRadius: '40px' }}>
                  <img
                    src="/assets/images/about-us-img-1.png"
                    alt="Dental clinic interior"
                    style={{ aspectRatio: '1/0.96', objectFit: 'cover', borderRadius: '40px', width: '100%', display: 'block' }} />
                  
                </figure>
              </div>

              <div className="about-img-2">
                <figure className="image-anime reveal" style={{ display: 'block', overflow: 'hidden', borderRadius: '40px' }}>
                  <img
                    src="/assets/images/about-us-img-2.png"
                    alt="Dentist with patient"
                    style={{ aspectRatio: '1/0.72', objectFit: 'cover', border: '7px solid #fff', borderRadius: '40px', display: 'block' }} />
                  
                </figure>
              </div>

              <div className="about-experience">
                <figure>
                  <img
                    src="https://html.awaikenthemes.com/dentaire/images/about-experience-circle.png"
                    alt="25 years experience badge"
                    style={{ animation: 'rotate 30s infinite linear' }} />
                  
                </figure>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-6">
            <div className="about-content">
              <div className="section-title">
                <h3
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease, transform 0.6s ease'
                  }}>
                  à propos de nous</h3>
                <h2
                  style={{
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s'
                  }}>
                  
                  <span>70 Ans d'Excellence</span> au Service de la Santé en Afrique
                </h2>
                <p
                  style={{
                    marginTop: '20px',
                    marginBottom: 0,
                    opacity: inView ? 1 : 0,
                    transform: inView ? 'translateY(0)' : 'translateY(20px)',
                    transition: 'opacity 0.6s ease 0.25s, transform 0.6s ease 0.25s'
                  }}>
                  
                  Fondé en 1954 par le Dr. Pierre Montagnier, premier laboratoire privé de biologie médicale en Côte d'Ivoire, COSA incarne aujourd'hui l'ambition de transformer le paysage des soins de santé en créant un réseau de centres médicaux d'excellence accessibles à tous.
                </p>
              </div>

              <div
                className="about-us-body"
                style={{
                  opacity: inView ? 1 : 0,
                  transform: inView ? 'translateY(0)' : 'translateY(20px)',
                  transition: 'opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s'
                }}>
                
                <ul>
                  <li>équipe médicale expérimentée</li>
                  <li>services complets et spécialisés</li>
                  <li>plateau technique de pointe</li>
                  <li>télémédecine et médecine de proximité</li>
                </ul>
              </div>

              <div
                className="about-us-footer"
                style={{
                  opacity: inView ? 1 : 0,
                  transform: inView ? 'translateY(0)' : 'translateY(20px)',
                  transition: 'opacity 0.6s ease 0.75s, transform 0.6s ease 0.75s'
                }}>
                
                <a href="#" className="btn-default">en savoir plus sur nous</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);

}